import ReactController from '~/controllers/react_controller'
import AWSEBSMetricsCharts from '~/dashboard/aws_ebs_metrics_charts'

export default class AWSEBSMetricsChartsController extends ReactController {
  static values = {
    organizationId: String,
    resourceId: String,
  }

  createComponent() {
    return <AWSEBSMetricsCharts organizationId={this.organizationIdValue} resourceId={this.resourceIdValue} />
  }
}
